import { shipmentDirections } from 'shared/helpers/constants/shipments/shipmentDirections';
import { shipmentStatuses } from 'shared/helpers/constants/shipments/shipmentStatuses';

const generateShipmentReportAccess = (auth, shipment) =>
  auth.access.shipments.generateReport &&
  shipment.status === shipmentStatuses.sent &&
  shipment.shipmentDirection === shipmentDirections.outgoing;

export { generateShipmentReportAccess };
